module.exports = __webpack_public_path__ + "img/edgefilter.6ab117ce.jpg";